import React, { useEffect, useRef } from 'react';
import { translate } from '../../Services/translation';

const ConfiguratorProductCard = ({
  product,
  isSelected,
  onSelect,
  showSelectButton = false,
}) => {
  const cardRef = useRef(null);
  // The select button disappears once the card is selected, so focus is moved to the card itself.
  const focusCardOnSelectRef = useRef(false);

  useEffect(() => {
    if (isSelected && focusCardOnSelectRef.current) {
      cardRef.current?.focus();
    }
    focusCardOnSelectRef.current = false;
  }, [isSelected]);

  return (
    <div
      ref={cardRef}
      tabIndex={-1}
      className={`configurator__product-card ${isSelected ? 'is-selected' : ''}`}
      onClick={onSelect ? () => {
        focusCardOnSelectRef.current = cardRef.current.contains(document.activeElement);
        onSelect(product);
      } : undefined}
      style={{
        cursor: onSelect ? 'pointer' : 'default',
        border: isSelected ? '2px solid #c00' : '',
      }}
    >
      {product.imageUrl && (
        <img src={product.imageUrl} alt={product.id} />
      )}
      <div className="configurator__product-info">
        <p className="configurator__product-name">{product.name}</p>
        <p className="configurator__product-art-nr">
          {translate('brenderup.configurator.product.art.nr')}: {product.id}
        </p>
        <p className="configurator__product-price">
          {translate('brenderup.configurator.product.price')}: {product.formattedPrice}
        </p>
        {showSelectButton && !isSelected && onSelect && (
          <button type="button" className="configurator__button-select-product">
            Välj modell
          </button>
        )}
      </div>
    </div>
  );
};

export default ConfiguratorProductCard;
